import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { AchievementService } from 'src/app/services/achievement.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { JournalService } from 'src/app/services/journal.service';
import { UserFeelsService } from 'src/app/services/user-feels.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';

@Component({
  selector: 'app-feel-well-index',
  templateUrl: './feel-well-index.component.html',
  styleUrls: ['./feel-well-index.component.scss'],
})
export class FeelWellIndexComponent implements OnInit {
  isLoading = false;
  userData: any;
  allEntries: any;
  feelWellWeekData: any;
  weekScore = 0;
  allTaskStatuses: any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();

  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    private userTaskStatusService: UserTaskStatusService,
    private userFeelWellService: UserFeelsService,
    public journalService: JournalService,
    private achievementService: AchievementService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.achievementService.refreshNotifications();
        this.isLoading = false;
      }
    });

    forkJoin({
      allEntries: this.userFeelWellService.fetchAll(),
      allUserTaskStatuses: this.userTaskStatusService.fetchAll(),
    }).subscribe(
      (responseData) => {
        this.allEntries = responseData.allEntries;

        this.feelWellWeekData = this.userFeelWellService.generateWeekArray(
          this.currentWeek,
          this.allEntries
        );

        this.weekScore = this.userFeelWellService.getWeekScore(
          this.feelWellWeekData
        );

        this.allTaskStatuses = responseData.allUserTaskStatuses;
        let readResources = this.userTaskStatusService.checkTaskStatus(
          this.allTaskStatuses,
          'FeelWellIntro'
        );
        if (!readResources) {
          this.router.navigate(['/modules', 'feel-well', 'resources']);
        }

        this.isLoading = false;
      },
      (error) => {}
    );
  }
}
